import React from 'react'
import { Link } from 'react-router-dom'
import { ChatInterface } from '../components/ChatInterface'
import { useChatStore } from '../store/chatStore'
import { useUserStore } from '../store/userStore'

const Home: React.FC = () => {
  const { clearMessages } = useChatStore()
  const { name } = useUserStore()

  const getTimeOfDay = () => {
    const hour = new Date().getHours()
    if (hour < 12) return 'morning'
    if (hour < 18) return 'afternoon'
    return 'evening'
  }

  return (
    <div
      className="min-h-screen p-2 sm:p-4"
      style={{
        backgroundImage: 'url("/images/chat-background.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* Navigation Bar */}
      <nav className="max-w-6xl mx-auto mb-6">
        <div className="flex justify-center gap-2">
          <Link to="/" className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2 ring-2 ring-blue-500">🏠 Home</Link>
          <Link to="/admin/create-project" className="bg-white/80 hover:bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2">🎨 Create Project</Link>
          <Link to="/file-sharing" className="bg-white/80 hover:bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2">📁 File Sharing</Link>
          <Link to="/vpn-clients" className="bg-white/80 hover:bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2">🔒 VPN Clients</Link>
          <Link to="/admin" className="bg-white/80 hover:bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2">⚙️ Admin</Link>
        </div>
      </nav>

      {/* Header */}
      <header className="mb-4 sm:mb-8 text-center">
        <div className="flex justify-center mb-2 sm:mb-4">
          <img src="/images/ed-character-logo.png" alt="Ask Ed Logo" className="h-20 sm:h-24 md:h-32" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold mb-1 sm:mb-2 text-primary drop-shadow-md">Ed</h1>
        <p className="text-base sm:text-lg text-muted-foreground mb-2">Your intelligent assistant</p>
        {name && (
          <div className="bg-white/70 backdrop-blur-sm py-1 sm:py-2 px-3 sm:px-4 rounded-full inline-block animate-[fadeIn_0.5s_ease-out]">
            <p className="text-sm sm:text-base text-primary font-medium">
              Good {getTimeOfDay()}, {name}! How can I assist you today?
            </p>
          </div>
        )}
      </header>

      <div className="max-w-6xl mx-auto">
        <div className="w-full">
          <div className="glass-effect rounded-xl shadow-xl p-6">
            <div className="flex justify-end mb-4">
              <button className="bg-white/80 p-2 rounded-md shadow-sm" onClick={() => clearMessages()}>
                New Chat
              </button>
            </div>
            <ChatInterface />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
